// import { React } from 'react';
// import { FormattedMessage } from 'react-intl';

export const DEFAULT_CUSTOMERS = {
  'en-KE': {
    initials: 'NC',
    fullName: 'No customer',
  },
  'bem-ZM': {
    initials: 'NC',
    fullName: 'No customer',
  },
  'en-ZM': {
    initials: 'NC',
    fullName: 'No customer',
  },
  'en-UG': {
    initials: 'NC',
    fullName: 'No customer',
  },
  'fr-GN': {
    initials: 'NC',
    fullName: 'No customer',
  },
  'sw-TZ': {
    initials: 'NC',
    fullName: 'No customer',
  },
  'sw-UG': {
    initials: 'NC',
    fullName: 'No customer',
  },
  'sw-KE': {
    initials: 'NC',
    fullName: 'No customer',
  },
  'en-NG': {
    initials: 'NC',
    fullName: 'No customer',
  },
  'en-ZW': {
    initials: 'NC',
    fullName: 'No customer',
  },
  'en-AE': {
    initials: 'NC',
    fullName: 'No customer',
  },
  'en-MW': {
    initials: 'NC',
    fullName: 'No customer',
  },
  'en-MU': {
    initials: 'NC',
    fullName: 'No customer',
  },
  'en-PH': {
    initials: 'NC',
    fullName: 'No customer',
  },
  'en-ZA': {
    initials: 'NC',
    fullName: 'No customer',
  },
  'ar-EG': {
    initials: 'NC',
    fullName: 'No customer',
  },
  'ar-UG': {
    initials: 'NC',
    fullName: 'No customer',
  },
  'fr-MG': {
    initials: 'NC',
    fullName: 'No customer',
  },
  'fr-KE': {
    initials: 'NC',
    fullName: 'No customer',
  },
  'fr-UG': {
    initials: 'NC',
    fullName: 'No customer',
  },
  'fr-CM': {
    initials: 'NC',
    fullName: 'No customer',
  },
  'en-CM': {
    initials: 'NC',
    fullName: 'No customer',
  },
};

export const LOCALES = ['ar-EG', 'ar-UG', 'bem-ZM', 'en-ZM', 'en-UG', 'fr-GN', 'sw-TZ', 'sw-UG', 'sw-KE', 'en-NG', 'en-ZW', 'en-AE', 'en-MW', 'en-MU', 'en-KE', 'en-PH', 'fr-MG', 'fr-UG', 'fr-KE', 'en-ZA', 'fr-CM', 'en-CM'];
export const DEFAULT_LOCALE = LOCALES[0];
export const DEFAULT_CURRENCY = 'EGP';
export const DAYS_DIFF = 14;
export const MAX_VALUE_FOR_QTY_IN_SALES = 10;
export const MAX_VALUE_FOR_PRICE_IN_SALES = 20;
export const DEFAULT_SALES_TAX = {
  name: 'IVA',
  percentage: 12,
};

export const CHECK_QTY_LENGTH = (qty) => {
  if (((!qty.includes('.') && qty.length <= MAX_VALUE_FOR_QTY_IN_SALES) || ((qty.includes('.') && qty.split('.')[1].length <= 2)
      && qty.split('.')[0].length <= MAX_VALUE_FOR_QTY_IN_SALES))) {
    return true;
  }
  return false;
};

export const FeedbackObj = {
  angry: {
    value: 1,
  },
  sad: {
    value: 2,
  },
  normal: {
    value: 3,
  },
  happy: {
    value: 4,
  },
  love: {
    value: 5,
  },
};

export default {
  DEFAULT_CUSTOMERS,
  LOCALES,
  FeedbackObj,
  DEFAULT_LOCALE,
  DEFAULT_CURRENCY,
  DEFAULT_SALES_TAX,
};

export const INCO_TERM_ARRAY = ['DDP', 'EXW', 'FCA'];

export const SELF_COLLECT_INCO_TERM = ['EXW', 'self_collect'];

export const DELIVERY_INCO_TERM = ['DDP', 'delivered', 'FCA', 'agency'];

export const TRUCK_SIZE_SELECTION = { DDP: false, EXW: false, FCA: false };

export const QTY_PER_DELIVERY = { DDP: [], EXW: [], FCA: [] };

export const FIND_INCOTERM_TYPE = (incoterm, isMdd) => {
  if (incoterm === 'DDP') {
    if (isMdd) {
      return 'MDD';
    }
    return 'delivered';
  } else if (incoterm === 'FCA') {
    return 'agency';
  } else if (incoterm === 'MDD') {
    return 'MDD';
  }
  return 'self_collect';
};

export const FIND_REVERSE_INCOTERM_TYPE = (type) => {
  if (type === 'delivered' || type === 'MDD') {
    return 'DDP';
  } else if (type === 'agency') {
    return 'FCA';
  }
  return 'EXW';
};
export const VAT_CONTAIN_COUNTRY_SELECTION = ['fr-CM'];
// export const FIND_FORMATMESSAGE_INCOTERM = (type) => {
//   if (type === 'delivered') {
//     return <FormattedMessage id="DigitalOrdering.Delivered" />;
//   } else if (type === 'agency') {
//     return <FormattedMessage id="DigitalOrdering.Agency" />;
//   } else if (type === 'MDD') {
//     return <FormattedMessage id="DigitalOrdering.MDD" />;
//   }
//   return <FormattedMessage id="DigitalOrdering.SelfCollect" />;
// };
